const LOGIN_REDIRECT_STORAGE_KEY = 'loginRedirectTo'

//--------------------------------------------------------------------------------
function isSafeRelativePath(path: string | null | undefined): path is string {
  if (!path) return false
  if (!path.startsWith('/')) return false
  if (path.startsWith('//')) return false
  return true
}

//--------------------------------------------------------------------------------
export function rememberLoginRedirectTarget(path: string) {
  if (!isSafeRelativePath(path)) return
  sessionStorage.setItem(LOGIN_REDIRECT_STORAGE_KEY, path)
}

//--------------------------------------------------------------------------------
export function consumeLoginRedirectTarget(): string | undefined {
  const stored = sessionStorage.getItem(LOGIN_REDIRECT_STORAGE_KEY)
  if (stored != null) {
    sessionStorage.removeItem(LOGIN_REDIRECT_STORAGE_KEY)
  }
  return isSafeRelativePath(stored) ? stored : undefined
}

//--------------------------------------------------------------------------------
export function resolveLoginRedirectTarget(search: string): string | undefined {
  const queryValue = new URLSearchParams(search).get('redirectTo')
  if (isSafeRelativePath(queryValue)) return queryValue
  return consumeLoginRedirectTarget()
}
